import { Plugin } from '@tiptap/pm/state'

import insertMedia, { MediaUploadOptions } from './insertMedia'

import { getFilesFromDragEvent, isMediaFile } from '~lib/utils/files'

// eslint-disable-next-line import/prefer-default-export
export const mediaDropPlugin = (options: MediaUploadOptions): Plugin => {
  return new Plugin({
    props: {
      handlePaste(view, event) {
        if (!event.clipboardData) return false

        const mediaFiles = Array.prototype.slice
          .call(event.clipboardData?.items || [])
          .map((dt) => dt.getAsFile())
          .filter((file) => file && isMediaFile(file))

        if (mediaFiles.length === 0) return false

        event.preventDefault()

        const { tr } = view.state
        if (!tr.selection.empty) {
          tr.deleteSelection()
        }
        const position = tr.selection.from
        insertMedia(view, position, mediaFiles, options)
        return true
      },
      handleDOMEvents: {
        drop: (view, event: DragEvent) => {
          const files = getFilesFromDragEvent(event)
          const mediaFiles = files.filter((file) => isMediaFile(file))

          if (mediaFiles.length === 0) {
            return false
          }

          event.preventDefault()

          const coordinates = view.posAtCoords({
            left: event.clientX,
            top: event.clientY,
          })

          if (coordinates) {
            const position = coordinates.pos
            insertMedia(view, position, mediaFiles, options)
            return true
          }

          return false
        },
      },
    },
  })
}
